// eslint-disable-next-line import/prefer-default-export
export const CATEGORY_COUNT_PER_PAGE = 6;
